import { useEffect, useState } from "react";
import iconEdit2 from "@iconify/icons-eva/edit-2-outline";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Button, Table, Stack, Avatar, TableRow, TableBody, TableCell, Container, Typography, TableContainer } from "@mui/material";
// components
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";

import axios from "axios";
import StringUtil from "src/utils/StringUtil";
import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import { alert } from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import Label from "src/components/Label";
import plusFill from "@iconify/icons-eva/plus-fill";
import { BALANCE_RECORD_TYPE_MAP, TRANSACTION_TYPE_MAP } from "src/config/constants";
import { asyncRequest } from "src/services/network";

const TABLE_HEAD = [
  { id: "id", label: "ID", alignRight: false },
  { id: "date", label: "日期", alignRight: false },
  { id: "total", label: "结算金额（元）", alignRight: false },
  { id: "remark", label: "备注", alignRight: false },
  { id: "createdAt", label: "创建时间", alignRight: false },
  { id: "操作" },
];

const moreMenus = [{ title: "详情", icon: iconEdit2 }];

export default function SupplierSettlement() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [filter, setFilter] = useState({
    page: 1,
    size: 10,
    search: "",
  });

  useEffect(() => {
    getItems();
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "/finance/settlement/list",
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }

  const handlePageChange = (event, value) => {
    const newPage = value;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  const handleMoreClick = (type, row) => {
    if (type === "详情") {
      // navigate(`/order/list?sn=${row.orderSN}`);
    }
  };

  const isUserNotFound = items.length === 0;

  return (
    <Page title="资金流水">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            资金流水
          </Typography>
        </Stack>

        <Card>
          <ListToolbar filterName={filter.search} onFilterName={handleFilterByName} onRefresh={getItems} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} />
                <TableBody>
                  {items.map((row) => {
                    const {
                      id,
                      user: { avatar, uid, mobile, nickname },
                      amount,
                      orderSN,
                      sn,
                      createdAt,
                      status,
                      type,
                      remark,
                    } = row;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox">
                        <TableCell align="left">{orderSN}</TableCell>
                        <TableCell align="left">{sn}</TableCell>
                        <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>
                        <TableCell component="th" scope="row">
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Avatar alt={nickname} src={avatar} />
                            <Typography variant="subtitle2" noWrap>
                              {nickname || mobile}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell align="left">{StringUtil.toFixed2(amount)}</TableCell>
                        <TableCell align="left"> {TRANSACTION_TYPE_MAP[type]}</TableCell>
                        <TableCell align="right">
                          <MoreMenu menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {/* {emptyRows > 0 && (
                    <TableRow style={{ height: 50 * emptyRows }}>
                      <TableCell colSpan={2} />
                    </TableRow>
                  )} */}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 5 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
        </Card>
      </Container>
    </Page>
  );
}
